<script lang="ts" setup>
import { SUPPORT_CATEGORY_ICONS } from '@consumer/modules/support/categoryIcons'

defineProps<{
  icon?: string
}>()
</script>

<template>
  <div class="rounded-md h-26 lg:h-36 px-6 lg:px-8 relative overflow-hidden">
    <h1 class="text-xl lg:text-2xl absolute left-6 lg:left-8 bottom-3 lg:bottom-6 text-navy">
      <slot/>
    </h1>

    <slot name="icon">
      <GIcon
        :icon="icon ? SUPPORT_CATEGORY_ICONS[icon] : undefined"
        color="primary-base"
        size="120px"
        class="
          absolute top-0 right-0 stroke-3 stroke-cap-round stroke-join-round opacity-20
          !lg:w-200px !lg:h-200px
        "
      />
    </slot>
  </div>
</template>
